import { getLinkToNoveListFromLinks, getAnchorTargetToNoveListFromLinks} from '../lib/LinksUtilities';

/**
* Create a new instance of series object
* @param  {object} seriesData A js object from novelist select
*/
class Series {

	constructor(seriesData) {
		this.title = seriesData.full_title;
		this.alternateTitle = seriesData.alternate_title;
		this.seriesNote = seriesData.series_note;
		this.linkToSeriesInNoveList = getLinkToNoveListFromLinks(seriesData.links);
		this.linkToSeriesInNoveListFullTarget = getAnchorTargetToNoveListFromLinks(seriesData.links);
		this.ui = seriesData.ui;
	}
}

export default Series;



// WEBPACK FOOTER //
// ./src/models/Series.js